<template>
  <div class="model-one">
      <!-- <img :src="$theme ? lightLogo : lightLogoEng" alt="" /> -->
      <div class="text" :class="{'text-eng': !$theme}">{{$theme ? 'AIoT接万物，缔造下一代工业智能' : 'AIot Connects Everything  Creates the Next Generation of Industrial Intelligence'}}</div>
      <div class="btn" @click="$emit('showVideo')">
        {{$theme ? "点击播放" : 'View details'}}
        <div class="quan">
          <div class="con">
            <i class="el-icon-right"></i>
            <i class="el-icon-right"></i>
          </div>
          
        </div>
      </div>
    </div>
</template>

<script>
import lightLogo from "/static/image/logo.svg";
import lightLogoEng from "/static/image/logo-eng-2x.png";
export default {
  data () {
    return {
      lightLogo,
      lightLogoEng,
    }
  },
  props: {},
  components: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {},
  watch: {}
}
</script>

<style scoped lang='scss'>
@import "./Index.scss";
</style>
